import type {
  Rate,
  RateAssessment,
  RateSupplement,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import unwrapList from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/unwrapList'

/**
 * Опубликованные дополнения пациента.
 *
 * В контексте это related-набор Django, не массив — без unwrap список пустой.
 */
export function getPublishedSupplements(rate: Rate): RateSupplement[] {
  return unwrapList(rate.published_supplements)
}

/**
 * Итоговая оценка карточки.
 *
 * Если есть дополнение, берётся его `avg_rate`:
 * пациент мог пересмотреть оценку после публикации отзыва.
 */
export function getAvgRate(rate: Rate): number | null {
  const [latestSupplement] = getPublishedSupplements(rate)

  if (latestSupplement && latestSupplement.avg_rate != null) {
    return latestSupplement.avg_rate
  }

  return rate.avg_rate ?? null
}

/**
 * Оценки по критериям для тултипов.
 *
 * Источник — последнее дополнение, иначе сам отзыв.
 * Пункты без названия отбрасываются: иначе в тултипе пустая строка.
 */
export function getRateAssessments(rate: Rate): RateAssessment[] {
  const [latestSupplement] = getPublishedSupplements(rate)
  const source = latestSupplement
    ? (latestSupplement.get_assessments || latestSupplement.assessments || [])
    : (rate.get_assessments || rate.assessments || [])

  return source.filter(assessment => Boolean(assessment.assessment_name || assessment.name))
}

/**
 * Откуда оставлен отзыв — для иконки источника.
 *
 * Запись через колл-центр важнее флага мобильного приложения:
 * иначе запись «через ПроДокторов» помечалась бы как обычный сайт.
 */
export function getReviewOrigin(rate: Rate): 'callCenter' | 'pdMobile' | 'site' {
  if (rate.is_appointment_throu_prodoctorov) {
    return 'callCenter'
  }

  if (rate.from_pd_mobile) {
    return 'pdMobile'
  }

  return 'site'
}
